<template>
  <v-menu v-model="isOpen" :close-on-content-click="false" min-width="290" offset-y>
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        v-model="textFieldValue"
        :label="label"
        :error-messages="errorMessages"
        :hide-details="hideDetails"
        :append-outer-icon="appendOuterIcon"
        :clearable="clearable"
        :disabled="disabled"
        prepend-icon="mdi-calendar"
        ref="textField"
        autocomplete="off"
        @blur="onBlur"
        @keyup.enter="onEnterClick"
        @click:append-outer="$emit('click:append-outer')"
      />
    </template>
    <v-date-picker
      :value="value"
      :locale="locale"
      first-day-of-week="1"
      no-title
      scrollable
      show-week
      @input="onInput"
    />
  </v-menu>
</template>

<script>
import i18n from '../../i18n/i18n-config';
import { format, getYear, isValid, setYear } from 'date-fns';

export default {
  name: 'BaseDatepickerInput',

  props: {
    clearable: {
      type: Boolean,
      default: true, // prop was added later, wanted to keep backwards compatibility
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: i18n.t('date'),
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    appendOuterIcon: {
      type: String,
      default: '',
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      textFieldValue: '',
    };
  },

  computed: {
    locale() {
      return this.$store.state.settings.locale;
    },
  },

  watch: {
    value: {
      handler(newValue) {
        this.textFieldValue = newValue;
      },
      immediate: true,
    },
  },

  methods: {
    onBlur(event) {
      if (event.target.value === this.value || this.value === null) {
        return;
      }
      let date = new Date(event.target.value);
      if (isValid(date)) {
        if (getYear(date) > 9999) {
          date = setYear(date, getYear(new Date()));
        }

        this.textFieldValue = format(date, 'yyyy-MM-dd');
        this.onInput(this.textFieldValue);
      } else {
        this.onInput('');
      }
    },

    onEnterClick(event) {
      event.target.blur();
    },

    onInput(val) {
      this.$emit('input', val);
      this.isOpen = false;
    },
  },
};
</script>

<style scoped></style>
